<template>
  <div class="main">
    <Button @click="schoolBtn(msg, schoolChange)">
      <Icon :type="icon" />{{ msg }}
    </Button>
    <Modal v-model="modal1" @on-cancel="cancel" footer-hide>
      <p slot="header">
        <span>{{ msg }}学校</span>
      </p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="学校名称" prop="schoolname">
          <el-input v-model="ruleForm.schoolname"></el-input>
        </el-form-item>
        <el-form-item label="学校性质">
          <el-select
            v-model="ruleForm.schoolnature"
            placeholder="请选择学校性质"
          >
            <el-option
              v-for="item in ItemOptions"
              :key="item.itemdetailid"
              :label="item.detailname"
              :value="item.itemdetailid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="英文名称">
          <el-input v-model="ruleForm.enshortname"></el-input>
        </el-form-item>
        <el-form-item label="中文简称">
          <el-input v-model="ruleForm.cnshortname"></el-input>
        </el-form-item>
        <el-form-item label="院校隶属">
          <el-input v-model="ruleForm.schoolaffiliation"></el-input>
        </el-form-item>
        <el-form-item label="院校类型">
          <el-input v-model="ruleForm.schooltype"></el-input>
        </el-form-item>
        <el-form-item label="学历层次">
          <el-input v-model="ruleForm.edulevel"></el-input>
        </el-form-item>
        <!-- <el-form-item label="上级院校">
          <el-select
            v-model="ruleForm.parentId"
            placeholder="请选择上级院校"
          >
            <el-option
              label="民办学校"
              value="minban"
            ></el-option>
            <el-option
              label="公办学校"
              value="gongban"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="成立时间">
          <el-date-picker
            v-model="ruleForm.foundedtime"
            type="datetime"
            placeholder="选择日期时间"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="负责人">
          <el-input v-model="ruleForm.manager"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="传真">
          <el-input v-model="ruleForm.fax"></el-input>
        </el-form-item>
        <el-form-item label="学校地点">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item label="邮编">
          <el-input v-model="ruleForm.postCode"></el-input>
        </el-form-item>
        <el-form-item label="学校官网">
          <el-input v-model="ruleForm.webaddress"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="ruleForm.description"></el-input>
        </el-form-item>
        <el-form-item style="position: relative; top: 90; right: -440px">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </Modal>
  </div>
</template>
<script>
import Api from "../api/index";
import moment from "moment";
moment.locale("zh-cn");

export default {
  data() {
    return {
      modal1: false,
      ruleForm: {
        schoolname: "",
        schoolnature: "",
        enshortname: "",
        cnshortname: "",
        schoolAffiliation: "",
        schoolType: "",
        eduLevel: "",
        parentId: "0d4bc22d669f48a6aa7d18df4872cea9",
        foundedtime: "",
        manager: "",
        phone: "",
        email: "",
        fax: "",
        address: "",
        postCode: "",
        webAddress: "",
        description: "",
      },
      ItemOptions: [],
      rules: {
        schoolname: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
        ],
      },
    };
  },
  props: {
    msg: String,
    icon: String,
    schoolChange: Object,
  },
  created() {
    this.GetSchoolTreeList();
    this.GetDataItemDetail();
  },
  methods: {
    //获取学校信息列表
    async GetSchoolTreeList() {
      const res = await Api.school.GetSchoolTreeList();
      if (res.success != true) return this.$Message.info(res.msg);
      this.schoolDataList = res.rows;
      this.$emit("SchoolTreeList", res.rows);
    },
    async GetDataItemDetail() {
      const res = await Api.dictionary.GetDataItemDetailTreeListByItemCode(
        "SchoolNature"
      );
      if (!res.success) return this.$Message.info(res.msg);
      this.ItemOptions = res.rows;
    },
    //学校按钮
    async schoolBtn(msg, schoolChange) {
      if (msg == "编辑" && JSON.stringify(schoolChange) == "{}") {
        return this.$Message.info("请选择编辑项!");
      } else if (msg == "编辑") {
        const res = await Api.school.GetSchoolInfo(schoolChange.schoolid);
        if (!res.success) return this.$Message.info(res.msg);
        this.ruleForm = res.rows;
      }
      this.modal1 = true;
    },
    cancel() {},

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.ruleForm.foundedtime) {
            let startDate = moment(this.ruleForm.foundedtime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            this.ruleForm.foundedtime = startDate;
          }
          const res = await Api.school.SaveDataItem(this.ruleForm);
          this.GetSchoolTreeList();
          this.$refs[formName].resetFields();
          if (res.success) this.modal1 = false;
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang='less' scoped>
/deep/.ivu-modal {
  width: 800px !important ;
}
.demo-ruleForm {
  overflow: hidden;
  width: 750px;
  height: 650px;
  > div {
    float: left;
    width: 50%;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 100%;
  }
}
</style>